import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { getCookies } from '../../hooks/useCookies';
import styles from './ToggleButton.module.scss';
import envValues from '../../enviornment';

function ToggleButtonOnOff({ value, id, URL }) {
  const [isOff, setIsOff] = useState(false);
  const Uri = URL || `${envValues.REACT_APP_API_ENDPOINT}/auth/toggle-change`;
  useEffect(() => {
    setIsOff(value);
  }, [value]);

  const handleButtonClick = () => {
    confirmAlert({
      title: 'Confirm to change status',
      message: 'Are you sure want to change status ?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            setIsOff(!isOff);
            const token = getCookies('Token');
            const headers = {
              'Content-Type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*',
              Authorization: `Bearer ${token}`,
            };
            const body = { token, userid: id, active: !isOff };
            axios.post(Uri, body, { headers }).then(() => {});
          },
        },
        {
          label: 'No',
          // onClick: () => alert("Click No")
        },
      ],
    });
  };
  return (
    <div className="col ">
      <label className={styles.switch}>
        <input type="checkbox" checked={isOff} onClick={handleButtonClick} />
        <span className={styles.slider} />
      </label>
    </div>
  );
}

ToggleButtonOnOff.propTypes = {
  value: PropTypes.bool,
  id: PropTypes.string,
  URL: PropTypes.string,
};
ToggleButtonOnOff.defaultProps = {
  value: false,
  id: null,
  URL: null,
};
export default ToggleButtonOnOff;
